/**
 * @generated SignedSource<<902a31a05153d729e87a5721c9b554cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DisplayType = "displayedToEveryone" | "displayedToSpecificUsers" | "notDisplayed" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PreviewPublishedNodeActionButton_TreeNodeFragment$data = {
  readonly hasBeenPublishedOnce: boolean;
  readonly id: string;
  readonly structureDefinition: {
    readonly extension?: {
      readonly displayType?: DisplayType;
    };
  };
  readonly " $fragmentType": "PreviewPublishedNodeActionButton_TreeNodeFragment";
};
export type PreviewPublishedNodeActionButton_TreeNodeFragment$key = {
  readonly " $data"?: PreviewPublishedNodeActionButton_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreviewPublishedNodeActionButton_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreviewPublishedNodeActionButton_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasBeenPublishedOnce",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "structureDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "extension",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayType",
                      "storageKey": null
                    }
                  ],
                  "type": "RootExtensionImpl",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "RootStructureDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "bfac9ca3eb43d06d4b8460b926f59f49";

export default node;
